/**
 * Enum of all table store ids.
 */
export enum TableStoreId {
  AccountSettings = 'accountSettings',
  Admins = 'admins',
  CustomFields = 'customFields',
  DailyChecks = 'dailyChecks',
  Datasets = 'datasets',
  Devices = 'devices',
  EmailTemplates = 'emailTemplates',
  Events = 'events',
  Files = 'files',
  FitTests = 'fitTests',
  Masks = 'masks',
  MedicalClearances = 'medicalClearances',
  People = 'people',
  PeoplePicker = 'peoplePicker'
}
